import { Stack } from '@mui/material';
import {
  RENEW_CONTRACT_OPTIONS,
  RenewContractOption,
} from '../renew-contract-dialog-types/renew-contract-option';
import React from 'react';
import { DocumentInvoiceContract, VyIcon } from '@vy/ui-design-system';
import { RenewContractStepOptionButton } from './RenewContractStepOptionButton';

type RenewContractStepOptionSelectorProps = {
  onSelect: (option: RenewContractOption) => void;
  selectedOption: RenewContractOption | null;
  setIsAutoRenewalChecked: React.Dispatch<React.SetStateAction<boolean>>;
  isAutoRenewalChecked: boolean;
};

export const RenewContractStepOptionSelector: React.FC<RenewContractStepOptionSelectorProps> = ({
  onSelect,
  selectedOption,
  setIsAutoRenewalChecked,
  isAutoRenewalChecked,
}) => {
  const handleToggleAutoRenew = () => {
    setIsAutoRenewalChecked((autoRenewal) => !autoRenewal);
  };

  return (
    <Stack
      direction="row"
      sx={{
        alignItems: "flex-start",
        gap: "16px"
      }}>
      <RenewContractStepOptionButton
        option={RENEW_CONTRACT_OPTIONS.Auto}
        onSelect={() => {
          handleToggleAutoRenew();
          onSelect(RENEW_CONTRACT_OPTIONS.Auto);
        }}
        icon={<DocumentInvoiceContract />}
        avatarBackground="#D8D2FF"
        description="Automatically renew the contract at the end of the term"
        isAutoRenewalChecked={isAutoRenewalChecked}
        isSelected={isOptionSelected(RENEW_CONTRACT_OPTIONS.Auto, selectedOption)}
      />
      <RenewContractStepOptionButton
        option={RENEW_CONTRACT_OPTIONS.SameTerms}
        onSelect={() => onSelect(RENEW_CONTRACT_OPTIONS.SameTerms)}
        icon={<VyIcon icon="CreditCard" strokeOpacity={1} color="black" />}
        avatarBackground="#B0D2FF"
        description="Update contract with pricing, duration, and billing structure"
        isSelected={isOptionSelected(RENEW_CONTRACT_OPTIONS.SameTerms, selectedOption)}
      />
      <RenewContractStepOptionButton
        option={RENEW_CONTRACT_OPTIONS.NewTerms}
        onSelect={() => onSelect(RENEW_CONTRACT_OPTIONS.NewTerms)}
        icon={<VyIcon icon="CursorSelectHand" strokeOpacity={1} color="black" />}
        avatarBackground="#A7EBB7"
        description="Create a contract from scratch with the terms and commercials"
        isSelected={isOptionSelected(RENEW_CONTRACT_OPTIONS.NewTerms, selectedOption)}
      />
    </Stack>
  );
};

function isOptionSelected(option: RenewContractOption, selectedOption: RenewContractOption | null) {
  return option === selectedOption;
}
